import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useUser } from '../context/UserContext';
import { ADMIN_HOME_PATH, HOME_PATH } from './routePaths';

/**
 * Layout for guest-only routes. If the user is authenticated,
 * redirects to consignor or admin home. Otherwise renders the child route (Outlet).
 */
export default function RedirectIfAuthenticated(): React.ReactElement {
  const { isAuthenticated, isInitialized, user } = useUser();

  if (!isInitialized) {
    return <CircularProgress />;
  }

  if (isAuthenticated) {
    return <Navigate to={user?.isAdmin ? ADMIN_HOME_PATH : HOME_PATH} replace />;
  }

  return <Outlet />;
}
